<template>
<div class="container-fluid">
  <donapp-dialog
    v-if="show"
    @close="closeUpload"
    title=""
    :header="$t('labels.change_logo')"
    v-on:submit="cropUpload"
    :disableOk="uploading"
    theme="merchant">
    <div class="text-center">
      <croppa :placeholder="$t('labels.choose_img')" v-model="croppa" @new-image-drawn="onNewImage" @zoom="onZoom" :width="256" :file-size="fileSize" :height="256" :prevent-white-space="true"/>
      <vue-slider :interval="0.001" @input="onSliderChange" ref="slider" v-model="sliderVal" :tooltip="false" :min="sliderMin" :max="sliderMax" :disabled="disabled" />
      <p>{{$t('labels.upload_logo')}}</p>
    </div>
  </donapp-dialog>
  <div class="mt17">
    <div class="card">
      <div class="card-content flex">
        <div class="first-column">
          <div class="card-header grey-bg clickable" :class="{ 'size-md-bg': !hasImg }" :style="{ 'background-image': 'url(' + merchantImg + ')' }" v-on:click="changePhoto">
            <div class="middle"  v-on:click="changePhoto">
               <i class="material-icons"  v-on:click="changePhoto">file_upload</i>
             </div>
            <div class="overlay" v-on:click="changePhoto" />
          </div>
          <tab-list gradient="gradient-merchant" :tabItems="tabItems" :selectedTab="selectedTab" v-on:tabSelected="onTabSelected"/>
        </div>
        <div class="second-column">
          <div class="tab-content">
            <div :class="{'tab-pane': true, active: tabItems[selectedTab].id === 'profile'}" id="profile">
              <div class="col-sm-12">
                <profile />
              </div>
            </div>
            <div :class="{'tab-pane': true, active: tabItems[selectedTab].id === 'payment-methods'}" id="payment-methods">
              <div class="col-sm-12">
                <payment-methods />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TabList from '@/components/shared/TabList'
import PaymentMethods from './PaymentMethods'
import Profile from './Profile'
import DonappDialog from '@/components/shared/Dialog'
import vueSlider from 'vue-slider-component'

export default {
  name: 'account',
  components: {
    TabList,
    PaymentMethods,
    Profile,
    DonappDialog,
    vueSlider
  },
  data() {
    return {
      selectedTab: 0,
      show: false,
      uploading: false,
      croppa: {},
      sliderVal: 0,
      sliderMin: 0,
      sliderMax: 0,
      disabled: true,
      fileSize: 102400
    }
  },
  mounted: function() {
    this.selectedTab = this.$route.query.sub ? this.$route.query.sub : 0
  },
  computed: {
    ...mapState({
      loggedRoleType: state => (state.user.loggedRole ? state.user.loggedRole.type : 'user'),
      loggedRole: state => (state.user.loggedRole ? state.user.loggedRole : state.user),
      merchant: state => state.user.loggedRole.merchant,
      tabItems: function(state) {
        let tabItems = [
          { id: 'profile', icon: 'icon-merchant_profile', label: this.$t('labels.profile') },
          { id: 'payment-methods', icon: 'icon-credit_card', label: this.$t('labels.payment_method') }
        ]
        return tabItems
      }
    }),
    hasImg: function() {
      return this.loggedRole.merchant.img && this.loggedRole.merchant.img.length > 2
    },
    merchantImg: function() {
      return this.hasImg ? this.loggedRole.merchant.img : './static/img/shop.svg'
    }
  },
  methods: {
    ...mapActions({
      changeProfileImg: 'changeProfileImg'
    }),
    onTabSelected: function(selected) {
      this.selectedTab = selected
    },
    changePhoto: function() {
      this.show = true
    },
    cropSuccess: function() {},
    cropUpload: async function() {
      this.uploading = true
      if (this.uploading) {
        try {
          const blob = await this.croppa.promisedBlob('image/jpeg')
          if (blob) {
            await this.changeProfileImg({
              type: 'merchants',
              profileId: this.merchant._id,
              blob
            })
            this.show = false
          } else {
            this.$toasted.error(this.$i18n.t('errors.something_wrong'))
          }
        } catch (error) {
          this.$toasted.error(error)
        }
        this.uploading = false
      }
    },
    cropUploadFail: function() {},
    cropUploadSuccess: function() {},
    closeUpload: function() {
      this.show = false
    },
    onNewImage() {
      this.sliderVal = this.croppa.scaleRatio
      this.sliderMin = this.croppa.scaleRatio / 2
      this.sliderMax = this.croppa.scaleRatio * 2
      this.disabled = false
    },

    onSliderChange(evt) {
      var increment = evt
      this.croppa.scaleRatio = +increment
    },

    onZoom() {
      this.sliderVal = this.croppa.scaleRatio
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/config.scss';

.croppa-container {
  font-size: 0 !important;
}

.card-header {
  width: 300px;
  height: 300px;
  padding: 0px !important;
  margin: -34px 0 17px 0px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: white;
}

.card-content {
  padding: 17px;
}

.title {
  @include biggestFontSize();
  line-height: 21px;
  letter-spacing: 1.05px;
}

.second-column {
  flex-grow: 1;
  padding: 0px 0px 0px 17px;

  .tab-pane .col-sm-12 {
    padding: 0px;
  }
}

.btn-sm {
  margin-left: 5px;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;

  i {
    color: white;
  }
}

.overlay {
  width: 100%;
  height: 100%;
  position: relative;
  margin-top: -50px;
  margin-right: 0px;
  margin-bottom: 17px;
  margin-left: 0px;
  border-radius: 8px;
  background-color: $grey;
  opacity: 0;
}

.card-header.clickable:hover {
  .middle {
    opacity: 1;
    z-index: 1;
    height: 50px;
  }

  .middle .material-icons {
    font-size: 50px;
  }

  .overlay {
    opacity: 0.6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/merchants/account/Account.vue